function resetInfiniteScroll() {

    if (typeof infiniteScrollOriginalLimit !== 'undefined') {
        infiniteScrollOriginalLimit = null;
    }

    const infiniteScrollComponent = document.getElementById('infinite_scroll_1');
    if (infiniteScrollComponent && infiniteScrollComponent.dmxComponent) {
        infiniteScrollComponent.dmxComponent.set('executing', false);
    }
}
